import { CURRENCIES, type Currency } from '@kon/shared';
import { useCurrency } from '@/context/CurrencyContext';
import styles from './CurrencySelector.module.css';

export function CurrencySelector() {
  const { currency, setCurrency } = useCurrency();
  return (
    <label className={styles.wrap}>
      <span className="sr-only">Display currency</span>
      <select
        className={styles.select}
        value={currency}
        onChange={(e) => setCurrency(e.target.value as Currency)}
      >
        {CURRENCIES.map((code) => (
          <option key={code} value={code}>
            {code}
          </option>
        ))}
      </select>
    </label>
  );
}
